import React from 'react';
import PropTypes from 'prop-types';
import { InlineIcon } from '../../../../../../inline-icon/inline-icon';
import styles from '../../card.scss';
import ArrowRightLongIcon from '../../../../../../../icons/compiled/components/ArrowRightLongIcon';
export class ProductCardContent extends React.Component {
    renderThumbnail() {
        const { cardData } = this.props;
        const { thumbnailUrl } = cardData;
        if (!thumbnailUrl) {
            return null;
        }
        return (React.createElement("div", { className: styles.thumbnail },
            React.createElement("div", { className: styles.image, style: { backgroundImage: `url(${thumbnailUrl})` } })));
    }
    renderText() {
        const { cardData } = this.props;
        const { text } = cardData;
        return (React.createElement("div", { className: styles.text },
            React.createElement("div", { className: styles['text-content'], "data-hook": "action-card-title" }, text)));
    }
    renderCta() {
        const { cardData } = this.props;
        const { buttonLabel } = cardData;
        return (React.createElement("div", { className: styles.cta },
            React.createElement("div", { className: styles['cta-label'], "data-hook": "action-card-action-text" }, buttonLabel),
            React.createElement("span", { className: styles['cta-icon-container'] },
                React.createElement(InlineIcon, { icon: React.createElement(ArrowRightLongIcon, null), className: styles['icon-arrow'] }))));
    }
    render() {
        const { className, isAriaHidden } = this.props;
        return (React.createElement("div", { className: className, "aria-hidden": isAriaHidden },
            this.renderThumbnail(),
            React.createElement("div", { className: styles.container },
                this.renderText(),
                this.renderCta())));
    }
}
ProductCardContent.propTypes = {
    cardData: PropTypes.object,
    className: PropTypes.string,
    isAriaHidden: PropTypes.bool,
};
//# sourceMappingURL=card-content.js.map